import { useNavigate } from "react-router-dom";


export default function AllPendingInvoicesTable() {
    const navigate = useNavigate();

    const handleNavigate = (invoiceno) => {
        navigate(`/${invoiceno}`);
    };

    const data = [
        { id: 1, invoiceno: "1111", invoicedate: "Wed 20 May 2022 ", status: "Sucess", amount: "$2000" },
        { id: 2, invoiceno: "2222", invoicedate: "Fri 22 May 2022 ", status: "Sucess", amount: "$2000" },
    ];



    return (
        <div className="customer-container my-4">
            <div className="special-header panel-white-all  ">
                <h4 className="page-title mt-1">Customer All Invoices</h4>
            </div>

            <div className="table-top-filters d-flex flex-wrap gap-3">

                <input type="text" className="form-control form-control-sm gap-2" placeholder="Invoice No " style={{ maxWidth: "200px" }} />

                <input type="text" className="form-control form-control-sm" placeholder="Status" style={{ maxWidth: "200px" }} />

                <button type="button" class="btn custom-btn">Clear</button>

            </div>

            <div className="card ">

                <div className="card-body p-0">



                    <div className="table-responsive">



                        <table className="custom-table">
                            <thead>
                                <tr>
                                    <th>Sr No</th>
                                    <th>Invoice No</th>
                                    <th>Invoice Date</th>
                                    <th>Amount</th>
                                    <th>status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((row) => (
                                    <tr key={row.id}>
                                        <td>{row.id}</td>
                                        <td>{row.invoiceno}</td>
                                        <td>{row.invoicedate}</td>
                                        <td>{row.amount}</td>
                                        <td>{row.status}</td>
                                       


                                        <div className="btn-group mb-2">
                                            <button
                                                type="button"
                                                className="btn"
                                                onClick={() => handleNavigate(row.invoiceno)}
                                                title="View"
                                            >
                                                <i class="bi bi-eye"></i>
                                            </button>
                                        </div>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}
